
<div mat-dialog-title>
  Portfolio Created
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
  <span class="stepsProgressIndicator">Step 4 of 4</span>
</div>
<mat-dialog-content>
    <div class="nameHeader">Portfolio: {{portfolioName}}</div>
    <div>You can go to the portfolio details now to assign a model, schedule recurring rebalances, and specify other settings.</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" class="btn-medium-secondary" (click)="close()" >Close - I'll do this later</button>
  <button id="portfolioDetailButton" class="btn-medium-primary" (click)="showPortfolioDetail()">Go to portfolio details</button>
</mat-dialog-actions>
